<h2 mat-dialog-title>{{ "Importerer dokumenter fra Microsoft OneDrive"|translate }}</h2>
@if (modus() == 'velgFiler') {
  <div class="picker-kontainer" #pickerKontainer></div>
  <!-- vi trenger å la bruker bytte microsoft-konto -->
  <div class="logut">
    <a (click)="logut()">Bruk en annen Microsoft OneDrive konto</a>
  </div>

} @else {
  <opplastingsstatus-skyfiler [filerUnderOpplasting]="valgteFilerMedOpplastingsstatus()"
                              [nyeVersjoner]="dokumenterMedNyVersjon()"
                              [modus]="opplastingsstatusModus()"
                              (vedStartOpplasting)="startOpplasting()"
                              (vedAvbryt)="avbrytLastOpp()"
                              (vedLukk)="lukk()"/>
}
